var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"text-caption error--text"},[_vm._v(" "+_vm._s(_vm.$t('Changing these settings requires products and shipping methods reindex'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }